<template>
    <div>
        <div
            v-if="loading"
            class="text-center p-4">
            <font-awesome-icon
                icon="circle-notch"
                spin
                size="2x" />
        </div>
        <div
            v-else-if="events && events.length"
            class="card p-4 overflow-hidden d-flex flex-column gap-4">
            <div v-for="(eventGroup, date) in eventsGroupedByDate">
                <h3>{{ date ? $df($moment(date), 'dateNumeric2DigitWeekday') : '-' }}</h3>
                <ul class="mb-0">
                    <li v-for="event in eventGroup">
                        <EventEntryLink
                            :event="event"
                            @open="$emit('update:showEvent', $event)" />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {groupBy} from 'lodash/collection'
import EventEntryLink from '@/components/pages/eventIFrame/EventEntry/EventEntryCompact/EventEntryLink'

export default {
    name: "IFrameEventCompactListing",
    components: {
        EventEntryLink
    },
    props: {
        events: {
            type: Array,
            required: true
        },
        iFrameType: {
            type: String,
            required: true
        },
        colorScheme: {
            type: Object,
            required: true
        },
        showNumberOfLoadingEntries: {
            type: Number,
            default: 0
        },
        showingSingleEvent: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        eventsGroupedByDate() {
            if (!this.events?.length) return null
            return groupBy(this.events, event => {
                return this.$moment(event.startDate).format('YYYY-MM-DD')
            })
        }
    },
    mounted() {
        this.$emit('hook:mounted')
    }
}
</script>

<style lang="scss" scoped>
</style>
